import * as React from 'react';
export const deelSvg = React.forwardRef(function deelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5938B7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M13.298 10.265C9.48 10.265 6 12.655 6 18.032c0 5.683 3.615 7.768 7.3 7.768 3.455 0 4.952-2.163 4.952-2.163v1.783h3.91a40.678 40.678 0 0 1-.138-3.53V6H18.25v6.448s-1.47-2.183-4.953-2.183Zm5.363 7.767c0 2.907-1.727 4.913-4.4 4.913-2.6 0-4.335-1.81-4.335-4.913 0-3.102 1.665-4.912 4.336-4.912 2.67 0 4.4 1.904 4.4 4.912Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M28 21.932h-3.635v3.476H28v-3.476Z',
    }),
  );
});
deelSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var deel = {
  category: 'brand',
  colorable: false,
  name: 'deel',
  svg: deelSvg,
};
